export default "__VITE_ASSET__DuG_6Dkq__"